// extracted by mini-css-extract-plugin
export var colorSquare = "_u2-0";
export var danger = "_u2-5";
export var lightPink = "_u2-8";
export var neutralBlue = "_u2-7";
export var neutralYellow = "_u2-6";
export var normal = "_u2-1";
export var primary = "_u2-2";
export var primaryLight = "_u2-3";
export var solidBlack = "_u2-g";
export var solidGreen = "_u2-b";
export var solidLightBlue = "_u2-d";
export var solidNavy = "_u2-c";
export var solidOrange = "_u2-f";
export var solidPink = "_u2-e";
export var solidRed = "_u2-9";
export var solidYellow = "_u2-a";
export var success = "_u2-4";